<template>
  <div
    class="flex items-start gap-2.5 bg-white border rounded-xl p-3 transition-colors"
    :class="overdue ? 'border-red-200 bg-red-50/40' : 'border-gray-100'"
  >
    <Checkbox
      :modelValue="task.completed"
      binary
      class="mt-0.5 flex-shrink-0"
      @update:modelValue="(v: boolean) => emit('toggle', v)"
    />
    <button type="button" class="flex-1 min-w-0 text-right" @click="emit('open')">
      <div
        class="text-sm font-medium text-gray-900"
        :class="{ 'line-through text-gray-400': task.completed }"
      >
        {{ task.title }}
      </div>
      <div class="flex items-center gap-2 mt-0.5 flex-wrap">
        <span class="text-[11px]" :class="overdue ? 'text-red-600 font-medium' : 'text-gray-500'">
          {{ showTime ? formatTime(task.dueDate) : relativeDate(task.dueDate) }}
        </span>
        <span v-if="task.leadTitle" class="text-[11px] text-primary-600 truncate">
          {{ task.leadTitle }}
        </span>
        <span v-else-if="task.businessName" class="text-[11px] text-gray-500 truncate">
          {{ task.businessName }}
        </span>
      </div>
    </button>
    <i v-if="task.leadId" class="pi pi-chevron-left text-gray-300 text-[10px] mt-1.5 flex-shrink-0" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { DateTime } from 'luxon';
import type { IPlatformReminder } from '@torim-app/types';
import { isTaskOverdue, relativeDate } from '../../composables/useLeadDisplay';

const props = defineProps<{ task: IPlatformReminder; showTime?: boolean }>();

const emit = defineEmits<{
  (e: 'toggle', completed: boolean): void;
  (e: 'open'): void;
}>();

const overdue = computed(() => isTaskOverdue(props.task));

const formatTime = (date: Date | string) => DateTime.fromJSDate(new Date(date)).toFormat('HH:mm');
</script>
